import { Box, Skeleton, Typography } from "@mui/material";

/**
 * SidebarLayoutSkeleton
 * Mimics the structure of SidebarLayout with placeholder blocks.
 * Includes: Header, Sidebar, Main Content, ChatBox placeholder.
 * No dynamic content, popups, or children rendered.
 * Responsive: shows HeaderMobile skeleton for mobile if needed.
 */
interface SidebarLayoutSkeletonProps {
  message?: string;
}

const SidebarLayoutSkeleton = ({ message }: SidebarLayoutSkeletonProps) => {
  return (
    <Box sx={{ flex: 1, height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Skeleton variant="rectangular" height={64} width="100%" sx={{ mb: 1 }} />

      <Box sx={{ display: "flex", flex: 1 }}>
        {/* Sidebar */}
        <Skeleton
          variant="rectangular"
          width={240}
          height="100%"
          sx={{ mr: 2, display: { xs: "none", lg: "block" } }}
        />

        {/* Main Content Area */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", position: "relative" }}>
          {/* HeaderMobile for mobile */}
          <Skeleton
            variant="rectangular"
            height={56}
            width="100%"
            sx={{ mb: 1, display: { xs: "block", sm: "block", lg: "none" } }}
          />
          {/* Main Content Box */}
          <Skeleton variant="rectangular" width="100%" height="80vh" sx={{ mb: 2 }} />
          {/* ChatBox placeholder (fixed bottom) */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height={56}
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              zIndex: 11
            }}
          />
        </Box>
      </Box>
      {/* Message area for identifying skeleton usage */}
      {message && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            position: "fixed",
            bottom: 8,
            left: 0,
            width: "100%",
            textAlign: "center",
            zIndex: 100,
            pointerEvents: "none",
            opacity: 0.8,
            fontStyle: "italic"
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default SidebarLayoutSkeleton;
